import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_exercise_results_path } from '@/modules/routes';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';

const SCOPES = {
  Assessment: 'for_assessment',
  Challenge: 'for_challenge',
  Game: 'for_game',
  ReadingGame: 'for_reading_games',
};

const useExerciseResult = () => {
  const assignment = useGradingStore(state => state.assignment);
  const student = useGradingStore(state => state.student);

  const isCorrectModelType = [
    'Assessment',
    'Challenge',
    'Game',
  ].includes(assignment.assignment_details.exercise_type);

  const scope = SCOPES[assignment?.assignment_details?.exercise_type];
  const isEnabled = Boolean(!!assignment && isCorrectModelType && scope);

  return useQuery({
    enabled: isEnabled,
    queryFn: () => (
      axios
        .get(plato_api_exercise_results_path({
          for_student: student.id,
          only: ['graded_at', 'id'],
          [scope]: assignment.assignment_details.exercise_id,
        }))
        .then((res) => {
          if (res.data.data) return res.data.data[0];

          return null;
        })
    ),
    queryKey: ['useExerciseResult', assignment?.assignment_details?.exercise_id, scope],
  });
};

export default useExerciseResult;
